import React, { Component } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import MobileNotification from '../common/MobileNotification';
import Button from '../common/Button';
import Schedule from '../common/Schedule';
import ResultsComponents from './ResultsComponents';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import SortBy from './SortBy';
import FilterBy from './FilterBy';
import MobileHeaderSearch from '../common/MobileHeaderSearch';
import { imageBasePath } from '../../constants/staticData';

export default class Results extends Component {
  constructor(props, context) {
    super(props, context);
    this.toggleNotification = this.toggleNotification.bind(this);
    this.state = {
      searchMobile: false,
      sortKey: '',
      filterParameters: false,
      notificationVisible: false,
      showSidebar: false,
    };
    this.sortChanged = this.sortChanged.bind(this);
    this.filterApplied = this.filterApplied.bind(this);
  }

  componentWillMount() {
    // document.body.addEventListener('mousedown', this.bodyClick.bind(this));
  }
  toggleNotification(isVisible) {
    this.setState({ 'notificationVisible': isVisible });
  }
  componentDidMount() {
    this.props.actions.clearCommonReducerComponentKey();
  }
  hclickCallBack() {
    this.setState({ showSidebar: !this.state.showSidebar })
  }
  // bodyClick(e) {
  //     if (e.target.closest('.sidebar') == null) {
  //         this.setState({ showSidebar: false })
  //     }
  // }
  sortChanged(selectedOption) {
    let sortKey = this.state.sortKey;
    if (selectedOption == "Nearest First") {
      sortKey = 'sortby=-distance';
    } else if (selectedOption == "Farthest First") {
      sortKey = 'sortby=distance';
    } else if (selectedOption == "Newest to Oldest") {
      sortKey = 'sortby=-date';
    } else if (selectedOption == "Oldest to Newest") {
      sortKey = 'sortby=date';
    }
    // this.props.actions.getOpenJobs(2, 10, 0, false, sortKey, this.state.filterParameters);
    this.setState({ sortKey: sortKey });
  }

  filterApplied(queryParams) {
    this.setState({ filterParameters: queryParams });
    // this.props.actions.getOpenJobs(2, 10, 0, false, this.state.sortKey, queryParams);
  }

  render() {
    const { commonReducer, jobRequestReducer, actions } = this.props;
    return (

      <div>
        {/*Header*/}
        <Header searchMobile={this.state.searchMobile} hideOption={() => this.setState({ searchMobile: true })} commonReducer={this.props.commonReducer} actions={this.props.actions} notificationCount={2} profileName="Derrick Frank" notificationCallBack={this.toggleNotification} authReducer={this.props.authReducer}
          hCallback={() => { this.hclickCallBack() }} router={this.props.router} />
        <MobileNotification isVisible={this.state.notificationVisible} backBtnCallBack={this.toggleNotification} />
        <div className="main-wrapper">
          {/*Sidebar*/}
          <Sidebar showSidebar={this.state.showSidebar} router={this.props.router} actions={this.props.actions} commonReducer={this.props.commonReducer} authReducer={this.props.authReducer} />
          <div className="container-fluid main-container">

            <div className="col-md-9 mpad0">

              <div className="overview-heading">

                <h5>{commonReducer.vendorsListFromSearch && commonReducer.vendorsListFromSearch.length ? commonReducer.vendorsListFromSearch.length : "No"} Results</h5>

                <div className="filter-section">
                  <SortBy sortCallback={this.sortChanged} />
                  <FilterBy actions={actions} jobRequestReducer={jobRequestReducer} filterApplied={this.filterApplied.bind(this)} />
                  <span className="map-icon">
                    <a href="">
                      <i className="mdi mdi-map" />
                      <label>Map</label>
                      <i className="mdi mdi-chevron-down" />
                    </a>
                  </span>
                </div>
              </div>
              {commonReducer.vendorsListFromSearch && commonReducer.vendorsListFromSearch.length ? <div className="content-view">
                <ResultsComponents router={this.props.router} resultList={commonReducer.vendorsListFromSearch} />
              </div> :
                <div className="content-view"> <div className="empty-state-holder"><span className="empty-state-content"><img src={`${imageBasePath}/search_empty.png`} /><span>Oops! We couldn’t find what you were looking for </span></span></div></div>}
            </div>
            <div className="col-md-3 mpad0 padLeft0">
              <Schedule commonReducer={this.props.commonReducer} router={this.props.router} />
            </div>
          </div>
        </div>
        {this.state.searchMobile && <div >

          <MobileHeaderSearch mobile={true} actions={this.props.actions} commonReducer={this.props.commonReducer} mobSearchClick={() => this.setState({ searchMobile: false })} />
        </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Results/Results.jsx